var _g, _path, _path2, _path3, _g2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 992,
    height: 302,
    viewBox: "0 0 992 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9669 187.593L15.6321 178.258C15.2588 178.12 14.8462 178.137 14.485 178.303C14.1237 178.47 13.8435 178.773 13.706 179.147L4.37082 204.482C4.23327 204.855 4.24965 205.268 4.41634 205.629C4.58304 205.99 4.8864 206.27 5.25969 206.408L30.5945 215.743C30.9678 215.88 31.3805 215.864 31.7417 215.697C32.1029 215.531 32.3831 215.227 32.5206 214.854L41.8558 189.519C41.9934 189.146 41.977 188.733 41.8103 188.372C41.6436 188.011 41.3402 187.731 40.9669 187.593ZM30.2243 212.409L7.70442 204.111L16.0024 181.591L38.5222 189.889L30.2243 212.409Z",
    fill: "#D8BCFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.113 7.7V0H139.18V2.75H121.047V0H113.113V7.7H115.947V25.3H113.113V33H121.047V30.25H139.18V33H147.113V25.3H144.28V7.7H147.113ZM141.447 2.2H144.847V5.5H141.447V2.2ZM115.38 5.5V2.2H118.78V5.5H115.38ZM118.78 30.8H115.38V27.5H118.78V30.8ZM144.847 27.5V30.8H141.447V27.5H144.847ZM142.013 23.1V25.3H139.18V28.05H121.047V25.3H118.213V7.7H121.047V4.95H139.18V7.7H142.013V23.1Z",
    fill: "#D8BCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.958 10.8906L125.165 20.4996H127.282L128.013 18.6476H132.214L132.945 20.4996H135.062L131.269 10.8906H128.958ZM128.789 16.6786L130.113 13.3256L131.437 16.6786H128.789Z",
    fill: "#D8BCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M871.809 87.8121L875.47 31.9033L921.29 64.148L871.809 87.8121ZM916.05 63.6762L877.788 36.7504L874.731 83.4368L916.05 63.6762Z",
    fill: "#90A9B4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.499 241.656L971.867 239.253L973.469 244.165L966.101 246.568L968.504 253.936L963.592 255.538L961.189 248.17L953.821 250.574L952.219 245.662L959.587 243.258L957.184 235.89L962.096 234.288L964.499 241.656ZM968.399 270.274L965.995 262.906L970.907 261.304L974.913 273.584L935.617 286.401L925.203 254.473L944.851 248.065L946.453 252.977L931.717 257.783L938.927 279.887L968.399 270.274Z",
    fill: "#D8BCFF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 684.613,
    cy: 204.5,
    r: 28,
    stroke: "#D8BCFF",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_1338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12.4473 173.887) rotate(20.2274)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11_1338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(913.028 242.141) rotate(-18.0648)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.b794a27e7e61aee7b8a8258d0ac736f2.svg";
export { ForwardRef as ReactComponent };